module.exports = __webpack_public_path__ + "static/conseils-315eab28cc4a17217134c76fcfb1b51a.jpg";